import React from "react";
import ContentLoader from "react-content-loader";
import { connect } from "react-redux";
import "./Loader.scss";

class CardLoad extends React.Component {
  render() {
    return (
      <ContentLoader
        speed={1}
        width={348}
        height={254}
        viewBox="0 0 348 254"
        backgroundColor={` ${this.props.darkMode ? "#19202d" : "#e4e3e3"}`}
        foregroundColor={` ${this.props.darkMode ? "#303742" : "#ecebeb"}`}
        {...this.props}
        className="loading--item"
        // style={{ marginRight: "35px", marginBottom: "20px" }}
      >
        <rect x="0" y="0" rx="0" ry="0" width="348" height="254" />
      </ContentLoader>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    darkMode: state.darkMode,
  };
};

export default connect(mapStateToProps)(CardLoad);
